/**
 * 二手车列表
 * http://mockjs.com/
url： https://testzsqy.cheanjia.com/?mock=1#/sms/4
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 二手车列表+get
// 接口地址 /api/v1/used_car/ticket/<int:ticket_id>/contract
Mock.mock(/used_car\/ticket\/\d+\/contract/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'images': [{
      'name': '车辆正面45度',
      'src': 'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg'
    },
    {
      'name': '合同',
      'src': 'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg'
    },
    {
      'name': '车钥匙',
      'src': 'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg'
    },
    {
      'name': '驾驶证',
      'src': 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1486298542971&di=70484f4dd636ab231331dd8e2a4be705&imgtype=0&src=http%3A%2F%2Fwww.leewiart.com%2Fuserfiles%2F24160%2F2592c71b5cdd404481d0634288dd7d90.jpg'
    }]
  }
})

// 二手车列表+get
// 接口地址 /api/v1/used_car/ticket/<int:ticket_id>/finish_images
Mock.mock(/used_car\/ticket\/\d+\/finish_images/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'images': [
      'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg',
      'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg',
      'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg',
      'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg',
      'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg',
      'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg'
    ]
  }
})
